import Utils from '@/lin/util/util'
import adminConfig from './admin'
import bookConfig from './book' // 引入图书管理路由文件
import pluginsConfig from './plugin'

// eslint-disable-next-line import/no-mutable-exports
let homeRouter = [
  {
    title: 'Home',
    type: 'view',
    name: Symbol('about'),
    route: '/about',
    filePath: 'view/about/about.vue',
    inNav: true,
    // icon: 'iconfont icon-iconset0103',
    icon:'House',
    isElementIcon: false,
    order: 1,
    // permission: ['数据看板'],
  },
  {
    title: 'Radar Plan',
    type: 'folder',
    name:null,
    route: null,
    filePath: 'view/radar/',
    inNav: true,
    icon: 'MapLocation',
    isElementIcon: false,
    // permission: ['创建雷达计划','雷达计划列表','粉丝洞察分析'],
    order: 1,
    children:[
      {
        title: 'Create Radar Plan',
        type: 'view',
        name: Symbol('radarInfo'),
        route: '/radarInfo',
        filePath: 'view/radar/radarInfo.vue',
        inNav: true,
        icon: 'iconfont icon-rizhiguanli',
        isElementIcon: false,
        order: 2
      },
      {
        title: 'Detection Task',
        type: 'view',
        name: Symbol('radarList'),
        route: '/radarList',
        filePath: 'view/radar/radarList.vue',
        inNav: true,
        icon: 'iconfont icon-rizhiguanli',
        isElementIcon: false,
        order: 2
      },
      {
        title: 'Insight Task',
        type: 'view',
        name: Symbol('insight'),
        route: '/insight',
        filePath: 'view/radar/insight.vue',
        inNav: true,
        icon: 'iconfont icon-rizhiguanli',
        isElementIcon: false,
        order: 2
      },
      {
        title: '粉丝洞察明细',
        type: 'view',
        name: Symbol('insightReport'),
        route: '/insightReport',
        filePath: 'view/radar/insightReport.vue',
        inNav: false,
        icon: 'iconfont icon-rizhiguanli',
        isElementIcon: false,
        order: 3
      },
      {
        title: '雷达粉丝明细',
        type: 'view',
        name: Symbol('radarfans'),
        route: '/radarfans',
        filePath: 'view/radar/radarfans.vue',
        inNav: false,
        icon: 'iconfont icon-rizhiguanli',
        isElementIcon: false,
        order: 3
      },
      
    ],
    // permission: ['雷达计划列表','创建雷达计划','粉丝洞察分析','粉丝洞察明细'],
  },
  {
    title: 'AI Interaction',
    type: 'folder',
    name:null,
    route: null,
    filePath: 'view/radar/',
    inNav: true,
    icon: 'Pointer',
    isElementIcon: false,
    // permission: ['创建雷达计划','雷达计划列表','粉丝洞察分析'],
    order: 1,
    children:[
      {
        title: 'Interaction Tutorial',
        type: 'view',
        name: Symbol('interactStep'),
        route: '/interactStep',
        filePath: 'view/interaction/interactStep.vue',
        inNav: true,
        icon: 'iconfont icon-rizhiguanli',
        isElementIcon: false,
        order: 2
      },
      {
        title: 'Interaction Task',
        type: 'view',
        name: Symbol('interactList'),
        route: '/interactList',
        filePath: 'view/interaction/interactList.vue',
        inNav: true,
        icon: 'iconfont icon-rizhiguanli',
        isElementIcon: false,
        order: 2
      },
      {
        title: 'Interaction Fans',
        type: 'view',
        name: Symbol('interactFans'),
        route: '/interactFans',
        filePath: 'view/interaction/interactFans.vue',
        inNav: false,
        icon: 'iconfont icon-rizhiguanli',
        isElementIcon: false,
        order: 2
      },
    ]
  },
  {
    title: 'Fans Data',
    type: 'folder',
    name:null,
    route: null,
    filePath: 'view/fans/',
    inNav: true,
    icon: 'DataAnalysis',
    isElementIcon: false,
    // permission: ['粉丝明细报表'],
    order: 1,
    children:[
      {
        title: 'Fans Detail',
        type: 'view',
        name: Symbol('hotbook'),
        route: '/hotbook',
        filePath: 'view/fans/hotbookReport.vue',
        inNav: true,
        icon: 'iconfont icon-rizhiguanli',
        isElementIcon: false,
        order: 2
      },
    ]
  },
  {
    title: 'Financial',
    type: 'view',
    name: Symbol('finance'),
    route: '/finance',
    filePath: 'view/finance.vue',
    inNav: true,
    icon: 'Notebook',
    isElementIcon: false,
    order: 1,
    // permission: ['财务管理'],
  },
  {
    title: 'Feedback',
    type: 'view',
    name: Symbol('feedback'),
    route: '/feedback',
    filePath: 'view/feedback.vue',
    inNav: true,
    icon: 'Headset',
    isElementIcon: false,
    order: 1,
    // permission: ['问题反馈'],
  },
  // {
  //   title: '用户管理',
  //   type: 'view',
  //   name: Symbol('userlist'),
  //   route: '/userlist',
  //   filePath: 'view/userlist.vue',
  //   inNav: true,
  //   icon: 'iconfont icon-rizhiguanli',
  //   isElementIcon: false,
  //   order: 1,
  //   permission: ['用户管理'],
  // },
  // {
  //   title: '预约管理',
  //   type: 'view',
  //   name: Symbol('log'),
  //   route: '/log',
  //   filePath: 'view/log/log.vue',
  //   inNav: true,
  //   icon: 'iconfont icon-rizhiguanli',
  //   isElementIcon: false,
  //   order: 1,
  //   permission: ['预约管理'],
  // },
  // {
  //   title: '消费管理',
  //   type: 'view',
  //   name: Symbol('sale'),
  //   route: '/sale',
  //   filePath: 'view/sale.vue',
  //   inNav: true,
  //   icon: 'iconfont icon-rizhiguanli',
  //   isElementIcon: false,
  //   order: 1,
  //   permission: ['消费管理'],
  // },
  // {
  //   title: '用户问题管理',
  //   type: 'view',
  //   name: Symbol('userInfo'),
  //   route: '/userInfo',
  //   filePath: 'view/userInfo.vue',
  //   inNav: false,
  //   icon: 'iconfont icon-rizhiguanli',
  //   isElementIcon: false,
  //   order: 1,
  //   permission: ['用户问答详情'],
  // },
  // {
  //   title: '问题管理',
  //   type: 'folder',
  //   name: null,
  //   route:null,
  //   filePath: 'view/question/',
  //   inNav: true,
  //   icon: 'iconfont icon-rizhiguanli',
  //   isElementIcon: false,
  //   order: 1,
  //   children:[
  //     {
  //       title: '问题列表',
  //       type: 'view',
  //       name: Symbol('questionlist'),
  //       route: '/questionlist',
  //       filePath: 'view/question/questionList.vue',
  //       inNav: true,
  //       icon: 'iconfont icon-rizhiguanli',
  //       isElementIcon: false,
  //       order: 2,
  //     },
  //     {
  //       title: '问题修改',
  //       type: 'view',
  //       name: Symbol('createQuestion'),
  //       route: 'createquestion',
  //       filePath:'view/question/createQuestion.vue',
  //       inNav: false,
  //       icon: 'iconfont icon-rizhiguanli',
  //       isElementIcon: false,
  //       order: 2,
  //     },
  //   ],
  //   permission: ['创建热门问题','热门问题列表','热门问题详情', '更新热门问题','删除热门问题'],
  // },
  
  // {
  //   title: '医院管理',
  //   type: 'folder',
  //   name: null,
  //   route:null,
  //   filePath: 'view/hospital/',
  //   inNav: true,
  //   icon: 'iconfont icon-rizhiguanli',
  //   isElementIcon: false,
  //   order: 1,
  //   children:[
  //     {
  //       title: '医院列表',
  //       type: 'view',
  //       name: Symbol('hospitalList'),
  //       route: '/hospitalList',
  //       filePath: 'view/hospital/hospitalList.vue',
  //       inNav: true,
  //       icon: 'iconfont icon-rizhiguanli',
  //       isElementIcon: false,
  //       order: 2
  //     },
  //     {
  //       title: '修改医院',
  //       type: 'view',
  //       name: Symbol('makeHospital'),
  //       route: '/makeHospital',
  //       filePath: 'view/hospital/makeHospital.vue',
  //       inNav: false,
  //       icon: 'iconfont icon-rizhiguanli',
  //       isElementIcon: false,
  //       order: 2
  //     },
  //   ],
  //   permission: ['医院管理','医院列表','修改医院','查看医院详情'],
  // },
  // {
  //   title: '项目管理',
  //   type: 'folder',
  //   name: null,
  //   route:null,
  //   filePath: 'view/project/',
  //   inNav: true,
  //   icon: 'iconfont icon-rizhiguanli',
  //   isElementIcon: false,
  //   order: 1,
  //   children:[
  //     {
  //       title: '项目列表',
  //       type: 'view',
  //       name: Symbol('projectList'),
  //       route: '/projectList',
  //       filePath: 'view/project/projectList.vue',
  //       inNav: true,
  //       icon: 'iconfont icon-rizhiguanli',
  //       isElementIcon: false,
  //       order: 2
  //     },
  //     {
  //       title: '修改项目',
  //       type: 'view',
  //       name: Symbol('makeProject'),
  //       route: '/makeProject',
  //       filePath: 'view/project/makeProject.vue',
  //       inNav: false,
  //       icon: 'iconfont icon-rizhiguanli',
  //       isElementIcon: false,
  //       order: 2
  //     },
  //   ],
  //   permission: ['项目管理','项目列表','修改项目','查看项目详情'],
  // },
  // {
  //   title: '医生管理',
  //   type: 'folder',
  //   name: null,
  //   route:null,
  //   inNav: true,
  //   filePath: 'view/doctor/',
  //   icon: 'iconfont icon-rizhiguanli',
  //   isElementIcon: false,
  //   order: 1,
  //   children:[
  //     {
  //       title: '医生列表',
  //       type: 'view',
  //       name: Symbol('doctorList'),
  //       route: '/doctorList',
  //       filePath: 'view/doctor/doctorList.vue',
  //       inNav: true,
  //       icon: 'iconfont icon-rizhiguanli',
  //       isElementIcon: false,
  //       order: 2
  //     },
  //     {
  //       title: '修改医生',
  //       type: 'view',
  //       name: Symbol('makeProject'),
  //       route: '/makeDoctor',
  //       filePath: 'view/doctor/makeDoctor.vue',
  //       inNav: false,
  //       icon: 'iconfont icon-rizhiguanli',
  //       isElementIcon: false,
  //       order: 2
  //     },
  //   ],
  //   permission: ['医生管理','医生列表','修改医生','查看医院详情'],
  // },

  // {
  //   title: '机构入驻',
  //   type: 'view',
  //   name: Symbol('shop'),
  //   route: '/shop',
  //   filePath: 'view/shop.vue',
  //   inNav: true,
  //   icon: 'iconfont icon-rizhiguanli',
  //   isElementIcon: false,
  //   permission: ['机构入驻列表','查看机构入驻详情','修改机构入驻'],
  //   order: 1
  // },
  // {
  //   title: '分类管理',
  //   type: 'view',
  //   name: Symbol('category'),
  //   route: '/categoryList',
  //   filePath: 'view/category/categoryList.vue',
  //   inNav: true,
  //   icon: 'iconfont icon-rizhiguanli',
  //   isElementIcon: false,
  //   permission: ['分类列表','创建一级分类','编辑分类信息'],
  //   order: 1
  // },
  // {
  //   title: '文案编辑管理',
  //   type: 'folder',
  //   name: null,
  //   route: null,
  //   filePath: 'view/writing/',
  //   inNav: true,
  //   icon: 'iconfont icon-rizhiguanli',
  //   isElementIcon: false,
  //   order: 1,
  //   children:[
  //     {
  //       title: '用户隐私协议',
  //       type: 'view',
  //       name: Symbol('privacy'),
  //       route: '/privacy',
  //       filePath: 'view/writing/privacy.vue',
  //       inNav: true,
  //       icon: 'iconfont icon-rizhiguanli',
  //       isElementIcon: false,
  //       order: 2
  //     },
  //     {
  //       title: '福利列表',
  //       type: 'view',
  //       name: Symbol('welfare'),
  //       route: '/welfare',
  //       filePath: 'view/writing/welfare.vue',
  //       inNav: true,
  //       icon: 'iconfont icon-rizhiguanli',
  //       isElementIcon: false,
  //       order: 2
  //     },
  //     {
  //       title: '福利详情',
  //       type: 'view',
  //       name: Symbol('makewelfare'),
  //       route: '/makewelfare',
  //       filePath: 'view/writing/makewelfare.vue',
  //       inNav: false,
  //       icon: 'iconfont icon-rizhiguanli',
  //       isElementIcon: false,
  //       order: 2
  //     },
  //     {
  //       title: '顶部广告文案',
  //       type: 'view',
  //       name: Symbol('top'),
  //       route: '/top',
  //       filePath: 'view/writing/top.vue',
  //       inNav: true,
  //       icon: 'iconfont icon-rizhiguanli',
  //       isElementIcon: false,
  //       order: 2
  //     }
  //   ],
  //   permission: ['首页文案','查看顶部文案','修改顶部文案','查看福利活动','创建福利活动','更新福利活动','下架福利活动'],
  // },
  // {
  //   title: '个人中心',
  //   type: 'view',
  //   name: Symbol('center'),
  //   route: '/center',
  //   filePath: 'view/center/center.vue',
  //   inNav: false,
  //   icon: 'iconfont icon-rizhiguanli',
  //   isElementIcon: false,
  //   permission:['个人中心']
  // },
  {
    title: '404',
    type: 'view',
    name: Symbol('404'),
    route: '/404',
    filePath: 'view/error-page/404.vue',
    inNav: false,
    icon: 'iconfont icon-rizhiguanli',
    isElementIcon: false,
  },
  bookConfig,
  adminConfig,
]

// 接入插件
// const plugins = [...pluginsConfig]
// filterPlugin(homeRouter)
// homeRouter = homeRouter.concat(plugins)

// 处理顺序
homeRouter = Utils.sortByOrder(homeRouter)
deepReduceName(homeRouter)

export default homeRouter

/**
 * 筛除已经被添加的插件
 */
function filterPlugin(data) {
  if (plugins.length === 0) {
    return
  }
  if (Array.isArray(data)) {
    data.forEach(item => {
      filterPlugin(item)
    })
  } else {
    const findResult = plugins.findIndex(item => data === item)
    if (findResult >= 0) {
      plugins.splice(findResult, 1)
    }
    if (data.children) {
      filterPlugin(data.children)
    }
  }
}

/**
 * 使用 Symbol 处理 name 字段, 保证唯一性
 */
function deepReduceName(target) {
  if (Array.isArray(target)) {
    target.forEach(item => {
      if (typeof item !== 'object') {
        return
      }
      deepReduceName(item)
    })
    return
  }
  if (typeof target === 'object') {
    if (typeof target.name !== 'symbol') {
      target.name = target.name || Utils.getRandomStr()
      target.name = Symbol(target.name)
    }

    if (Array.isArray(target.children)) {
      target.children.forEach(item => {
        if (typeof item !== 'object') {
          return
        }
        deepReduceName(item)
      })
    }
  }
}
